/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { RegularButton } from 'pg-ui-library';
import arrowSvg from 'src/assets/arrowExpand.svg';
import { IBank } from 'src/interfaces';
import { DefaultTable } from 'src/components';
import PersonalInfoService from 'src/services/personal-info.service';
import { MainTitle, EmergencyHeader, SeparatorLineStraight, ExpandIcon, Collapsible, BelowTitle } from './styles';
import { BanksFormModal } from './bank-modal';
import { PersonalInfoForm } from '../..';

interface BankResponse {
  message: string;
  data: IBank[];
}

const customStyles = {
  headRow: {
    style: {
      border: 'none',
    },
  },
  headCells: {
    style: {
      color: '#9399B2',
      paddingTop: '20px',
      paddingLeft: '27px',
      paddingBottom: '20px',
      font: 'normal normal bold 18px Biotif',
    },
  },
  rows: {
    style: {
      font: 'normal normal normal 18px Biotif',
      color: '#1B1D35',
      '&:not(:last-of-type)': {
        borderBottomWidth: '0px',
      },
    },
    stripedStyle: {
      color: '#1B1D35',
      backgroundColor: '#F3F4F8',
    },
    highlightOnHoverStyle: {
      backgroundColor: 'rgb(10, 41, 41)',
      borderBottomColor: '#FFFFFF',
      borderRadius: '25px',
      outline: '1px solid #FFFFFF',
    },
  },
  cells: {
    style: {
      justifyContent: 'left',
      paddingTop: '20px',
      paddingLeft: '27px',
      paddingBottom: '20px',
    },
  },
  pagination: {
    style: {
      display: 'none',
      border: 'none',
      svg: {
        fill: 'rgba(0,0,0,0.54)',
      },
    },
  },
};

const columns = [
  {
    name: 'Bank Name',
    selector: (row: { name: any }) => row.name,
    sortable: true,
  },
  {
    name: 'Account ID',
    selector: (row: { accountId: any }) => row.accountId,
    sortable: true,
  },
  {
    name: 'Account Number',
    selector: (row: { accountNumber: any }) => row.accountNumber,
    sortable: true,
  },
  {
    name: 'Type',
    selector: (row: { type: string }) => row.type?.toLowerCase(),
    sortable: true,
  },
];

const BankForm: React.FC<PersonalInfoForm> = ({ personalInfo }) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [isTableOpen, setIsTableOpen] = useState(true);

  // NEW: Local state for fetched bank data
  const [workerBanks, setWorkerBanks] = useState<IBank[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const { data: banks, isLoading } = useQuery<any>(['user-banks'], async () => {
    const result = await PersonalInfoService.getUserBanksInfo();
    return result;
  });

  useEffect(() => {
    if (banks?.data) {
      setWorkerBanks(banks.data);
    }
  }, [banks]);

  const toggleModal = () => setIsOpen(!modalIsOpen);
  const toggleTable = () => setIsTableOpen(!isTableOpen);

  return (
    <>
      <BanksFormModal isOpen={modalIsOpen} setIsOpen={setIsOpen} isUpdate={false} personnelNumber="" />

      <div style={{ boxShadow: '0px 0px 6px #E3E3E3', borderRadius: '10px' }}>
        {/* <EmergencyHeader>
          <MainTitle>
            <ExpandIcon src={arrowSvg} onClick={toggleTable} isOpen={!isTableOpen} />
            Bank Accounts
          </MainTitle>
          <div style={{ marginTop: '15px', marginRight: '27px' }}>
            <RegularButton type="button" onClick={toggleModal}>
              Add
            </RegularButton>
          </div>
        </EmergencyHeader>
        <SeparatorLineStraight />
        <div>
          <Collapsible isOpen={isTableOpen}>
            {loading ? (
              <div style={{ textAlign: 'center', padding: '2rem' }}>Loading...</div>
            ) : error ? (
              <div style={{ textAlign: 'center', padding: '2rem', color: 'red' }}>{error}</div>
            ) : (
              <DefaultTable
                columns={columns}
                data={workerBanks}
                customStyles={customStyles}
                noDataComponent={<div style={{ textAlign: 'center', padding: '2rem' }}>No bank accounts found</div>}
              />
            )}
          </Collapsible>
        </div> */}
        <BelowTitle />
      </div>
    </>
  );
};

export default BankForm;
